<!-- 
-->
<template>
    <div id="viewTransactionView">
        <div class="w-full flex p-8 flex-wrap lg:flex-no-wrap">
            <div class="w-full">
                <table style="min-width:100%" class="border-2 border-grey border-solid">
                    <tr>
                        <th>Transaction Type</th>
                        <td>{{ transactionData.TransactionType }}</td>
                    </tr>
                    <tr>
                        <th>Seller's certificate</th>
                        <td>{{ transactionData.SellersCertificateType }}</td>
                    </tr>
                    <tr>
                        <th>Sold as certificate</th>
                        <td>{{ transactionData.SoldAsCertificateType }}</td>
                    </tr>
                    <tr>
                        <th>{{ (transactionData.TransactionType=="Sale")?"Buyer":"Seller" }}</th>
                        <td>{{ transactionData.TransactionOtherPartyOperationName }}</td>
                    </tr>
                    <tr>
                        <th>{{ (transactionData.TransactionType!="Sale")?"Buyer":"Seller" }}</th>
                        <td>{{ transactionData.TransactionInitiatingPartyOperationName }}</td>
                    </tr>
                    <tr>
                        <th>Product</th>
                        <td>{{ transactionData.ProductName }}</td>
                    </tr>
                    <tr>
                        <th>Quantity</th>
                        <td>
                            {{ getQuantityWithUnit(transactionData.QuantityInGrams) }}
                            {{ $store.state.globalSettings.WEIGHT_UNIT.label }}
                        </td>
                    </tr>
                    <tr>
                        <th>Transaction Date</th>
                        <td>{{ dateTimeFormatter(transactionData.TransactionactionDate) }}</td>
                    </tr>
                    <tr>
                        <th>Record created on</th>
                        <td style="padding-bottom:28px">
                            {{ dateTimeFormatter(transactionData.TransactionactionRecordedOnDB) }}
                        </td>
                    </tr>
                </table>
            </div>

            <div class="w-full">
                <mapbox
                    :accessToken="$store.state.globalSettings.MAP_OPTIONS.accessToken"
                    :map-options="getCustomMapOptions()"
                    @map-init="mapInitialized"
                    :nav-control="{ show: true, position: 'bottom-right' }"
                    :scale-control="{ show: true, position: 'bottom-left' }"
                    :fullscreen-control="{ show: false, position: 'top-left' }"
                >
                </mapbox>
            </div>
        </div>
    </div>
</template>

<script>
import asyncRequest from "./../../utils/asyncRequest.js";
import Mapbox from "mapbox-gl-vue";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import axios from "axios";
import turfCenter from "@turf/center";
import { fromGramsTo } from "../../utils/weightConverter.js";

var _get = require("lodash.get");

export default {
    name: "CreateTradeView",
    created() {
        var txID = this.$route.params.id;
        if (!parseInt(txID)) {
            alert("The transaction you want to view is not specified. Please check your URL.");
        }
        this.findTransaction(txID);
    },
    data() {
        return {
            initedMap: null,
            Map: null,
            transactionData: {}
        };
    },
    computed: {},
    methods: {
        findTransaction(transactionID) {
            var URL = this.$store.state.urls.GET_TRANSACTION_BY_TRANSACTION_ID;

            URL = URL + transactionID + "/";

            asyncRequest.ServerAPI({
                progressBarObj: this.$Progress,
                method: "GET",
                api: URL,
                onSuccessCallback: dataIn => {
                    this.onGetTXData(dataIn);
                },
                flags: asyncRequest.M_FAIL,
                beforeAfterCallback: false
            });
        },
        getQuantityWithUnit(valIn) {
            var decimalPoints = 4;
            var retVal = fromGramsTo(this.$store.state.globalSettings.WEIGHT_UNIT.value, valIn, decimalPoints);
            return retVal;
        },
        onGetTXData(dataIn) {
            this.transactionData = dataIn.Data;
            this.transactionData.OtherPartyType = "Buyer";

            var lngLat = {
                lng: this.transactionData.TransactionLocationGPSLon,
                lat: this.transactionData.TransactionLocationGPSLat
            };

            this.Map.flyTo({
                center: lngLat,
                zoom: 13
            });

            var el = document.createElement("div");
            el.id = "markerpopup1";
            el.className = "markerpopup";

            var htmlCode =
                "<div class='cstmPopup'>" +
                "<div class='innerHtmlPopupTxType'>" +
                this.transactionData.TransactionType +
                "</div><br>" +
                "<div class='innerHtmlPopupTxDate'>" +
                this.dateTimeFormatter(this.transactionData.TransactionactionDate) +
                "</div></div></div>";
            //Understand this is kinna risky as we are opening ourselves to xss by doing this
            var popup = new mapboxgl.Popup({ offset: 30 }).setHTML(htmlCode);

            var marker = new mapboxgl.Marker(el);
            marker.setLngLat(lngLat);
            marker.setPopup(popup);
            marker.addTo(this.Map);
        },
        getCustomMapOptions() {
            var mapOptions = JSON.parse(JSON.stringify(this.$store.state.globalSettings.MAP_OPTIONS));
            mapOptions.zoom = 5;
            return mapOptions;
        },
        mapInitialized(mapIn) {
            this.initedMap = mapIn;
            //Add the geo coder
            //mapIn.addControl(this.Geocoder);
            this.Map = mapIn;
        },
        getTxProductQuantity() {
            return "";
        },
        dateTimeFormatter(dataIn) {
            return this.$dateFns.format(new Date(dataIn), "Do-MMMM-YYYY", {
                locale: this.$dateFns.locale
            });
        }
    },
    components: { Mapbox }
};
</script>

<style>
#viewTransactionView {
    min-height: calc(100vh - 172px);
}
#viewTransactionView th {
    min-width: 25%;
}
#viewTransactionView #map {
    height: 100%;
    min-height: 510px;
}
#viewTransactionView .mapboxgl-canvas {
    position: inherit !important;
}
#viewTransactionView .markerpopup {
    background-image: url("https://sunrisefoods.ca/wordpress/wp-content/themes/sunrise/app/images/icon-map.png");
    background-size: cover;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: pointer;
}
#viewTransactionView .cstmPopup {
    padding: 20px;
}
#viewTransactionView .innerHtmlPopupTxType {
    font-weight: bold;
}
#viewTransactionView .innerHtmlPopupTxDate {
    font-style: italic;
}
</style>
